import { useSnackbar } from 'notistack';
import { useState } from 'react';
import {
  IconButton, Dialog,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { SimpleUserSearch } from 'components/UserSearch/SimpleUserSearch';
import { User } from 'lib/types/users';
// import { useApi } from 'lib/contexts/ApplicationState';

interface Props {
  onClose: () => void;
  postOwner?: User;
}

export const PostOwnerModal = ({ onClose, postOwner }: Props) => {
//   const API = useApi();
  const { enqueueSnackbar } = useSnackbar();
  const [owner, setOwner] = useState(postOwner);

  const onSave = () => {
    try {
      // todo: save
      enqueueSnackbar('Post owner updated', { variant: 'success' });
      onClose();
    } catch (err) {
      enqueueSnackbar('Something went wrong updating post owner', { variant: 'error' });
    }
  };

  return (
    <Dialog fullWidth open aria-labelledby="form-dialog-title">
      <div className="p-6">
        <div className="absolute right-3 top-3">
          <IconButton aria-label="close" onClick={onClose}>
            <CloseIcon color="primary" />
          </IconButton>
        </div>
        Update post owner
        <div className="my-4">
          <SimpleUserSearch
            label="Post Owner"
            onChange={(_, value) => {
              setOwner(value);
            }}
            value={owner}
          />
        </div>
        <button
          type="button"
          className="btn-secondary"
          onClick={onSave}
          disabled={owner?.id === postOwner?.id}
        >
          Save
        </button>
      </div>
    </Dialog>
  );
};
